import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Subscribe to real-time legislative status changes and show toast alerts.
 * Also listens to legislative_tracker updates for direct status changes.
 */
export function useLegislativeAlerts() {
  useEffect(() => {
    const historyChannel = supabase
      .channel("legislative-alerts")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "legislative_status_history",
        },
        (payload) => {
          const { bill_number, old_status, new_status } = payload.new as {
            bill_number: string;
            old_status: string | null;
            new_status: string;
          };

          toast.warning(`⚡ Legislative Alert: ${bill_number}`, {
            description: old_status
              ? `Status changed: "${old_status}" → "${new_status}"`
              : `New status: "${new_status}"`,
            duration: 10000,
          });
        }
      )
      .on(
        "postgres_changes",
        {
          event: "UPDATE",
          schema: "public",
          table: "legislative_tracker",
        },
        (payload) => {
          const { bill_number, title, status } = payload.new as {
            bill_number: string;
            title: string;
            status: string;
          };

          toast.info(`📋 ${bill_number}: ${title}`, {
            description: `Current status: ${status}`,
            duration: 8000,
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(historyChannel);
    };
  }, []);
}
